import { cardItems } from '@/mocks/cinema';

const tagStyles: Record<string, string> = {
  '热播': 'bg-accent-500/20 text-accent-400 border-accent-500/30',
  '热门': 'bg-primary-500/20 text-primary-400 border-primary-500/30',
  '新剧': 'bg-secondary-500/20 text-secondary-400 border-secondary-500/30',
  '推荐': 'bg-primary-500/15 text-primary-400 border-primary-500/25',
  '经典': 'bg-foreground-500/15 text-foreground-400 border-foreground-500/25',
  '高分': 'bg-accent-500/15 text-accent-400 border-accent-500/25',
};

export default function SectionCards() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-100">
      <div className="section-container px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-100 mb-3">
            精选推荐
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            编辑精心挑选，每一部都值得熬夜追完
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {cardItems.map((card) => (
            <a
              key={card.title}
              href="#ranking"
              className="group bg-background-50 rounded-xl border border-background-200/30 overflow-hidden hover:border-primary-500/20 transition-all duration-200 cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/60 via-transparent to-transparent" />
                <span
                  className={`absolute top-2 right-2 px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap border ${
                    tagStyles[card.tag] || tagStyles['推荐']
                  }`}
                >
                  {card.tag}
                </span>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm md:text-base font-heading text-foreground-200 mb-1 truncate">
                  {card.title}
                </h3>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-600">{card.category}</span>
                  <div className="flex items-center gap-1">
                    <i className="ri-star-fill text-xs text-primary-400" />
                    <span className="text-xs font-medium text-primary-400">{card.rating}</span>
                  </div>
                </div>
                <div className="mt-2 text-xs text-foreground-600">{card.episodes}</div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}